import { DOMHelper } from "../Helpers/DOMHelper.js";
import { PmDatalayer } from "./PmDatalayer.js";

export class PmDRSDatalayer extends PmDatalayer {

    constructor(app) {
        super(app.pmdrs.pmCustomerAPI); // new server
        this.app = app;         
        this.resetSessionId();
    }

    resetSessionId(){
        this.setSessionId(this.app.pmdrs.getSessionId());
    }

    init() {
        this.addHandlers();        
    }

    addExternalHandlers(selectors) {
        selectors.forEach(selector => {
            DOMHelper.addHandler(
                this.app.getSelector(selector.selector),
                "click",
                (event) => {
                    this.generalClickEvent(selector.section, selector.element, event.target);
                }
            )
        });
    }

    addHandlers() {
        var dataLayer = this;

        var generalClickEvents = [
            { selector: '.pmdrs-widget .pmdrs-personalize-deal-btn', section: PmDRSDatalayer.CTA_BTN, element: 'DRA opened' },

            { selector: '.pmdrs-tabs-head .pmdrs-tab.balloon-tab', section: PmDRSDatalayer.TABS_SECTION, element: 'balloon tab clicked' },
            { selector: '.pmdrs-tabs-head .pmdrs-tab.finance-tab', section: PmDRSDatalayer.TABS_SECTION, element: 'finance tab clicked' },
            { selector: '.pmdrs-tabs-head .pmdrs-tab.premier-tab', section: PmDRSDatalayer.TABS_SECTION, element: 'premier tab clicked' },
            { selector: '.pmdrs-tabs-head .pmdrs-tab.lease-tab', section: PmDRSDatalayer.TABS_SECTION, element: 'lease tab clicked' },
            { selector: '.pmdrs-tabs-head .pmdrs-tab.ttf-tab', section: PmDRSDatalayer.TABS_SECTION, element: 'ttf tab clicked' },
            { selector: '.pmdrs-tabs-head .pmdrs-tab.cash-tab', section: PmDRSDatalayer.TABS_SECTION, element: 'cash tab clicked' },
            { selector: '.vehicle-image .vehicle-img', section: PmDRSDatalayer.HEADER_SECTION, element: 'vehicle image' },
            { selector: '.header-info-section .seedetails', section: PmDRSDatalayer.HEADER_SECTION, element: 'modal button' },
            { selector: '.header-info-section a.disclaimer-title', section: PmDRSDatalayer.HEADER_SECTION, element: 'modal button' },
            { selector: '.header-info-section .step-btn', section: 'header', element: 'step button'},
            
            { selector: '.contact-form-section .contact-form-group input', section: PmDRSDatalayer.CONTACT_INFO_SECTION, element: 'form field'},
            { selector: '.contact-form-section .contact-contact-method', section: PmDRSDatalayer.CONTACT_INFO_SECTION, element: 'form field'},
            
            { selector: '.start-contact-confirmation .continue-btn', section: PmDRSDatalayer.TY_MODAL_SECTION, element: 'continue button'},
            { selector: '.start-contact-confirmation p', section: PmDRSDatalayer.TY_MODAL_SECTION, element: 'text content'},
            { selector: '.start-contact-confirmation .step-btn', section: PmDRSDatalayer.TY_MODAL_SECTION, element: 'step button'},
            { selector: '.start-contact-confirmation .drs-close-modal-btn', section: PmDRSDatalayer.TY_MODAL_SECTION, element: 'close modal button'},
            
            // accessory select/unselect tracking is fired directly from AccessoriesSection.js's
            // own toggle handler instead of bound here - this selector is only attached once at
            // page load (see addHandler below), so it never sees the class toggling that happens
            // on the same node afterward and would keep reporting the node's original label
            // forever regardless of its actual state.
            { selector: '.accessories-section .accessory-more-info', section: PmDRSDatalayer.ACCESSORIES_SECTION, element: 'accessory more info button'},
            { selector: '.accessories-section .accessories-slider .slider-left', section: PmDRSDatalayer.ACCESSORIES_SECTION, element: 'previous accessory button'},
            { selector: '.accessories-section .accessories-slider .slider-right', section: PmDRSDatalayer.ACCESSORIES_SECTION, element: 'next accessory button'},
            { selector: '.accessories-section .step-btn', section: PmDRSDatalayer.ACCESSORIES_SECTION, element: 'step button'},

            { selector: '.accessory-modal-class #acc-modal-gallery-viewer', section: PmDRSDatalayer.ACCESSORIES_INFO_MODAL_SECTION, element: 'selected image'},
            // { selector: '.accessory-modal-class #acc-modal-gallery img:not([data-video])', section: PmDRSDatalayer.ACCESSORIES_INFO_MODAL_SECTION, element: 'gallery img thumb'},
            { selector: '.accessory-modal-class .acc-select-info', section: PmDRSDatalayer.ACCESSORIES_INFO_MODAL_SECTION, element: 'accessory select button'},
            { selector: '.accessory-modal-class .drs-close-modal-btn', section: PmDRSDatalayer.ACCESSORIES_INFO_MODAL_SECTION, element: 'close modal button'},
            
            { selector: '.tradein-section #tradein-include', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'trade in option'},            
            { selector: '.tradein-section .contact-form-group input', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'form field'},
            { selector: '.tradein-section .tradein-condition', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'trade in condition'},
            { selector: '.tradein-section #openDragDropModal', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'trade in images open modal'},
            { selector: '.tradein-section .drs-select select', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'form field'},
            { selector: '.tradein-section .contact-form-group select', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'form field'},
            { selector: '.tradein-section .upload-images-button', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'modal button'},
            { selector: '.tradein-section #imagesTradeInModal', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'modal button'},
            { selector: '.tradein-section textarea', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'form field'},
            { selector: '.tradein-section .step-btn', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'step button'},

            { selector: '.your-payment-section .payment-option-box', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'payment option'},
            // A native <select>'s "click" only reliably reflects the post-selection value when a
            // real mouse gesture opens+closes it in one motion (click fires on mouseup, after the
            // browser applies the new value); anything that sets the value another way (keyboard
            // nav, or a programmatic/automation-driven selection) can fire "click" before the new
            // value lands, or skip it entirely — confirmed live: term logged the OLD value one
            // step behind, and credit score (bound the same way) logged no event at all. "change"
            // is the one DOM event guaranteed to fire only once the new value is actually committed,
            // so every select-based tracker below binds to that instead of relying on the ambient
            // "click" bubbling through the box (kept above only for the non-select clicks inside a
            // box — disclaimer links, "Learn more" — that have no "change" event of their own).
            { selector: '.your-payment-section select[name="monthlyTermField"]', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'payment option', eventType: 'change'},
            { selector: '.your-payment-section select[name="mpyField"]', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'payment option', eventType: 'change'},
            // dedicated tab-switch tracking: bound directly to the tab curtain so switching
            // Finance/Lease/Cash/Balloon is unambiguous in the log (elementName comes from the
            // curtain's own name="finance|lease|cash|balloon" attribute)
            { selector: '.your-payment-section .payment-option-box .click-curtain', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'payment option tab'},
            { selector: '.your-payment-section .contact-form-group input', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'form field'},
            // cash down needs the post-edit value, not whatever was there when the user clicked
            // into the field, so this fires on change/blur rather than the generic click above
            { selector: '.your-payment-section .payment-cashdown', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'cash down', eventType: 'change'},
            // split out of a single generic ".contact-form-group select" entry that used to match
            // both of these selects and mislabeled both "select credit-score" (a copy-paste leftover)
            { selector: '.your-payment-section .retailing-credit-score-select', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'select credit-score', eventType: 'change'},
            { selector: '.your-payment-section .make-a-deposit', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'select deposit', eventType: 'change'},
            { selector: '.your-payment-section .apply-taxes-button', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'apply taxes'},
            { selector: '.your-payment-section .apply-taxes-button2', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'apply taxes'},//LenderDesk driver variant of the button above
            { selector: '.your-payment-section .pmdrs-input-slider input', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'input slider'},
            { selector: '.your-payment-section .drs-select select', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'form field'},
            // { selector: '.your-payment-section .pmdrs-cond-offers-list', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'offers click'},
            { selector: '.your-payment-section .apply-down-payment-button', section: PmDRSDatalayer.PAYMENT_SECTION, element: 'apply downpayment'},

            { selector: '#submitFloatButton', section: PmDRSDatalayer.FOOTER_SECTION, element: 'modal button'},
            
            { selector: '.start-need-help-modal .text-us-group input', section: PmDRSDatalayer.TEXT_US_SECTION, element: 'form field'},
            { selector: '.start-need-help-modal textarea', section: PmDRSDatalayer.TEXT_US_SECTION, element: 'form field'},

            { selector: '.start-drag-and-drop-modal #drag-drop-open-folder', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'select images trade-in' },
            { selector: '.start-drag-and-drop-modal #footer-upload', section: PmDRSDatalayer.TRADE_IN_SECTION, element: 'upload images trade-in' },

            { selector: '.payment-summary-section .submit-button', section: PmDRSDatalayer.PAYMENT_SUMMARY_SECTION, element: 'submit' },
        ];

        generalClickEvents.forEach((item)=> {
            DOMHelper.addHandler(
                this.app.getSelector(item.selector),
                item.eventType || "click",
                (event) => {
                    console.log("Pm dataLayer selector: " + item.selector);
                    let callback = () => {};
                    if (item.selector == ".pmdrs-widget .pmdrs-personalize-deal-btn") {
                        callback = () => {
                            this.app.pmdrs.frontApp.initCustomerJourney(this.app);
                        }
                    }
                    dataLayer.generalClickEvent(item.section, item.element, event.target, callback());
                }
            );
        });

        //VIDEO INTERACTIONS
        var videoEvents = [
            { selector: '.accessory-modal-class #acc-modal-gallery img[data-video]', section: PmDatalayer.ACCESSORIES_INFO_MODAL_SECTION, action:"play"}
        ];

        videoEvents.forEach(item => {
            DOMHelper.addHandler(
                this.app.getSelector(item.selector), 
                "click", 
                (event) => {                    
                    dataLayer.videoInteractionEvent(item.section, item.action);
                }
            );
        });

        //SUBMIT EVENTS // commented out because click on submit is not a good idea
        // var submitEvents = [
        //     { selector: '.start-need-help-modal #twilio-submit', section: PmDatalayer.TEXT_US_SECTION, element: 'submit button'},
        // ];

        // submitEvents.forEach(item => {
        //     DOMHelper.addHandler(
        //         this.app.getSelector(item.selector), 
        //         "click", 
        //         (event) => {                    
        //             dataLayer.submitEvent(item.section, item.element, event.target);
        //         }
        //     );
        // });

        //CHAT CLICK EVENT + IMPRESSION
        DOMHelper.addHandler(
            this.app.getSelector('.need-help-btn'),
            "click", 
            (event) => {   
                dataLayer.chatImpressionEvent(PmDatalayer.TEXT_US_SECTION);                
                dataLayer.chatClickEvent(PmDatalayer.TEXT_US_SECTION);                
            }
        );
    }

}

PmDRSDatalayer.TABS_SECTION = "tabs";
PmDRSDatalayer.HEADER_SECTION = "header";
PmDRSDatalayer.CONTACT_INFO_SECTION = "contact information";
PmDRSDatalayer.TY_MODAL_SECTION = "thank you modal";
PmDRSDatalayer.ACCESSORIES_SECTION = "accessories";
PmDRSDatalayer.ACCESSORIES_INFO_MODAL_SECTION = "accessories info modal";
PmDRSDatalayer.TRADE_IN_SECTION = "trade in";
PmDRSDatalayer.PAYMENT_SECTION = "payment";
PmDRSDatalayer.FOOTER_SECTION = "footer";
PmDRSDatalayer.TEXT_US_SECTION = "text us modal";
PmDRSDatalayer.SCHEDULE_TEST_RIDE_SECTION = "schedule test ride";
PmDRSDatalayer.PRE_APPROVED_SECTION = "pre approved";
PmDRSDatalayer.PAYMENT_SUMMARY_SECTION = "payment summary";
PmDRSDatalayer.CTA_BTN = "cta button";
